import api from './api';
import { ApiResponse, Appointment, PaginatedResponse, RoomResource } from '../types';

export interface AppointmentFilters {
  date?:     string;
  dateFrom?: string;
  dateTo?:   string;
  stylist?:  string;
  status?:   string;
}

export interface DayStats {
  total: number; pending: number; confirmed: number; arrived: number;
  inservice: number; completed: number; cancelled: number; noshow: number;
  sales: number; due: number;
  paymentSplit: { cash: number; card: number; online: number };
}

export interface CreateAppointmentDto {
  clientId:  string;
  date:      string;
  startTime: string;
  services:  { service: string; stylist: string; duration: number; price: number }[];
  source?:   string;
  notes?:    string;
  room?:     string;
  repeatBooking?: boolean;
  repeatFrequency?:'daily'|'weekly'|'monthly';repeatUntil?:string;status?:string;
}

export interface AppointmentCompletionDto {
  completedAt: string;
  instructions?: string;
  youtubeUrl?: string;
  attachmentUrl?: string;
  attachmentKey?: string;
  attachmentName?: string;
  attachmentType?: string;
  attachmentSize?: number;
}

const appointmentService = {
  getAll: (filters: AppointmentFilters = {}) =>
    api.get<PaginatedResponse<Appointment>>('/appointments', { params: filters }).then(r => r.data),

  getById: (id: string) =>
    api.get<ApiResponse<Appointment>>(`/appointments/${id}`).then(r => r.data),

  create: (data: CreateAppointmentDto) =>
    api.post<ApiResponse<Appointment>>('/appointments', data).then(r => r.data),

  update: (id: string, data: Partial<CreateAppointmentDto>) =>
    api.put<ApiResponse<Appointment>>(`/appointments/${id}`, data).then(r => r.data),

  updateStatus: (id: string, status: string, completion?: AppointmentCompletionDto) =>
    api.patch<ApiResponse<Appointment>>(`/appointments/${id}/status`, { status, completion }).then(r => r.data),

  cancel: (id: string, reason?: string) =>
    api.post<ApiResponse<Appointment>>(`/appointments/${id}/cancel`, { reason }).then(r => r.data),

  getAvailableSlots: (date: string, stylist?: string, duration?: number) =>
    api.get<ApiResponse<string[]>>('/appointments/slots', { params: { date, stylist, duration } }).then(r => r.data),

  getStats: (date: string) =>
    api.get<ApiResponse<DayStats>>('/appointments/stats', { params: { date } }).then(r => r.data),

  getRooms: () =>
    api.get<ApiResponse<RoomResource[]>>('/appointments/rooms').then(r => r.data),

  reschedule: (id: string, date: string, startTime: string) =>
    api.patch<ApiResponse<Appointment>>(`/appointments/${id}/reschedule`, { date, startTime }).then(r => r.data),

  submitFeedback: (id: string, rating: number, comment?: string) =>
    api.patch<ApiResponse<Appointment>>(`/appointments/${id}/feedback`, { rating, comment }).then(r => r.data),
};

export default appointmentService;
